/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

export type ErrorGroupEventsStatus =
  (typeof ErrorGroupEventsStatus)[keyof typeof ErrorGroupEventsStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ErrorGroupEventsStatus = {
  ignored: "ignored",
  open: "open",
  resolved: "resolved",
} as const;
